/* ============================================================
   BoT App-UI Port v4 — home blocks + Liquid Glass lens engine for .bottom-nav
   v3: rect-based visible() (offsetParent is null on position:fixed
   bars, which blocked boot entirely in v2), live node collection,
   MutationObserver re-sync, delayed boot, inline dock hardening.
   ES5. No external deps.
   ============================================================ */
(function(){
  "use strict";
  if (window.__botAppUI) return; window.__botAppUI = true;

  function ready(fn){
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function(){

    /* ---- home blocks: weekday greeting, relocate Smart Analysis +
       AM/PM routes into the page flow, gold sub-kickers ---- */
    (function(){
      var greet = document.getElementById("buiGreet");
      if (greet){
        var days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
        var gp = greet.getAttribute("data-prefix") || "Happy";
        var gs = greet.getAttribute("data-suffix") || "Beautiful.";
        greet.innerHTML = gp + " " + days[new Date().getDay()] + ",<br>" + gs;
      }
    })();

    var bar = document.querySelector(".bottom-nav");
    if (!bar) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* ---- LIVE item collection: re-query every time ---- */
    function getItems(){
      var out = [];
      for (var i = 0; i < bar.children.length; i++){
        var c = bar.children[i];
        if (c.tagName === "A" || c.tagName === "BUTTON") out.push(c);
      }
      return out;
    }

    /* wrap stray text nodes so labels can fade in min state */
    function wrapLabels(){
      getItems().forEach(function(el){
        for (var n = el.childNodes.length - 1; n >= 0; n--){
          var nd = el.childNodes[n];
          if (nd.nodeType === 3 && nd.textContent.replace(/\s+/g, "")){
            var sp = document.createElement("span");
            sp.className = "bn-lb";
            sp.textContent = nd.textContent.trim();
            el.replaceChild(sp, nd);
          } else if (nd.nodeType === 1 && nd.tagName === "SPAN"){
            nd.classList.add("bn-lb");
          }
        }
      });
    }

    /* inject lens */
    var lens = document.createElement("div");
    lens.className = "bn-lens";
    bar.insertBefore(lens, bar.firstChild);

    /* geometry — items + centers refreshed together */
    var items = [], centers = [], barLeft = 0, barW = 0, lensW = 60;
    function visible(){
      var r = bar.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }
    function measure(){
      if (!visible()) return;
      items = getItems();
      var br = bar.getBoundingClientRect();
      barLeft = br.left; barW = br.width;
      centers = items.map(function(el){
        var r = el.getBoundingClientRect();
        return r.left - br.left + r.width / 2;
      });
      if (items.length){
        lensW = Math.max(54, Math.min(76, (items[0].getBoundingClientRect().width || 60) + 6));
        lens.style.width = lensW + "px";
      }
    }

    function nearestIdx(x){
      var best = 0, bd = 1e9;
      for (var i = 0; i < centers.length; i++){
        var d = Math.abs(centers[i] - x);
        if (d < bd){ bd = d; best = i; }
      }
      return best;
    }

    /* spring state */
    var X = 0, V = 0, TX = 0, mode = "snap", running = false, lastT = 0;
    var dragging = false, dragMoved = false, curIdx = 0, lastNear = -1;
    var K_SNAP = 560, C_SNAP = 32, K_FOLLOW = 820, C_FOLLOW = 46;

    function render(){
      var sx = 1 + Math.min(.10, Math.abs(V) * .0012) + (dragging && dragMoved ? .02 : 0);
      var sy = Math.max(.95, 1 - (sx - 1) * .5);
      lens.style.transform = "translateX(" + (X - lensW / 2) + "px) scale(" + sx.toFixed(3) + "," + sy.toFixed(3) + ")";
      if (!reduce){
        for (var i = 0; i < items.length; i++){
          var d = centers[i] - X;
          var g = Math.exp(-(d * d) / 3872);
          items[i].style.transform = "translateY(" + (-1.5 * g).toFixed(2) + "px) scale(" + (1 + .07 * g).toFixed(3) + ")";
        }
      }
      var n = nearestIdx(X);
      if (n !== lastNear){
        lastNear = n;
        if (dragging && navigator.vibrate){ try{ navigator.vibrate(5); }catch(e){} }
      }
    }

    function step(t){
      if (!lastT) lastT = t;
      var dt = Math.min(.032, (t - lastT) / 1000); lastT = t;
      var k = mode === "snap" ? K_SNAP : K_FOLLOW;
      var c = mode === "snap" ? C_SNAP : C_FOLLOW;
      var a = k * (TX - X) - c * V;
      V += a * dt; X += V * dt;
      render();
      if (!dragging && Math.abs(V) < .02 && Math.abs(TX - X) < .1){
        X = TX; V = 0; render(); running = false; lastT = 0; return;
      }
      requestAnimationFrame(step);
    }
    function run(){ if (!running){ running = true; lastT = 0; requestAnimationFrame(step); } }

    function snapTo(idx, instant){
      curIdx = idx; TX = centers[idx] || 0; mode = "snap";
      if (instant || reduce){ X = TX; V = 0; render(); }
      else run();
    }

    /* unified tap + drag: release commits nearest LIVE item */
    var allowClick = false, suppressNext = false;
    bar.addEventListener("click", function(e){
      if (allowClick) return;
      if (suppressNext){
        suppressNext = false;
        e.preventDefault(); e.stopPropagation();
      }
    }, true);

    function commit(idx){
      snapTo(idx);
      var el = items[idx];
      if (!el || !el.isConnected){ measure(); el = items[idx]; }
      if (!el) return;
      allowClick = true;
      try{ el.click(); } finally { allowClick = false; }
    }

    bar.addEventListener("pointerdown", function(e){
      if (!visible()) return;
      measure();
      dragging = true; dragMoved = false;
      mode = "follow";
      TX = Math.max(lensW/2, Math.min(barW - lensW/2, e.clientX - barLeft));
      try{ bar.setPointerCapture(e.pointerId); }catch(err){}
      e.preventDefault();
      run();
    });
    bar.addEventListener("pointermove", function(e){
      if (!dragging) return;
      var x = Math.max(lensW/2, Math.min(barW - lensW/2, e.clientX - barLeft));
      if (Math.abs(x - TX) > 3) dragMoved = true;
      TX = x; run();
    });
    function endDrag(e, cancel){
      if (!dragging) return;
      dragging = false;
      suppressNext = true;
      if (cancel){ snapTo(curIdx); return; }
      var idx = nearestIdx(Math.max(0, Math.min(barW, e.clientX - barLeft)));
      commit(idx);
    }
    bar.addEventListener("pointerup", function(e){ endDrag(e, false); });
    bar.addEventListener("pointercancel", function(e){ endDrag(e, true); });

    /* re-sync when beauty-bottom-sheet.js swaps the buttons */
    if (window.MutationObserver){
      new MutationObserver(function(){
        wrapLabels();
        measure();
        snapTo(curIdx, true);
      }).observe(bar, { childList: true });
    }

    /* scroll-minimise (bn-min) removed 5 Jul 2026 per T — the shrink/restore
       cycle while scrolling read as a glitch. Bar now keeps a constant height. */

    window.addEventListener("resize", function(){
      applyDockSkin();
      measure(); snapTo(curIdx, true);
    });

    /* inline dock hardening — beats any stylesheet conflict */
    function applyDockSkin(){
      if (window.innerWidth > 991){
        bar.style.cssText = bar.style.cssText
          .replace(/left:[^;]+;?|right:[^;]+;?|bottom:[^;]+;?|border-radius:[^;]+;?/g, "");
        return;
      }
      var s = bar.style;
      s.left = "10px"; s.right = "10px";
      s.bottom = "calc(10px + env(safe-area-inset-bottom, 0px))";
      s.borderRadius = "30px";
      s.background = "linear-gradient(180deg, rgba(243,248,246,.82), rgba(232,241,237,.62))";
      s.webkitBackdropFilter = "blur(22px) saturate(185%)";
      s.backdropFilter = "blur(22px) saturate(185%)";
      s.border = "1px solid rgba(255,255,255,.7)";
      s.boxShadow = "0 12px 30px rgba(22,44,39,.18), 0 2px 6px rgba(22,44,39,.07), inset 0 1px 0 rgba(255,255,255,.9)";
      s.padding = "0 6px";
    }

    /* initial rest: item matching this page, else first item */
    function initialIdx(){
      try{
        for (var i = 0; i < items.length; i++){
          if (items[i].tagName === "A" && items[i].href){
            var u = new URL(items[i].href, location.origin);
            if (u.pathname === location.pathname) return i;
          }
        }
      }catch(e){}
      return 0;
    }

    /* boot AFTER the sheet engine's clone pass (it runs at
       DOMContentLoaded / +100ms) — 350ms covers it, then the
       MutationObserver covers anything later */
    var bootTries = 0;
    function boot(){
      /* bar stays hidden on desktop (min-width:992px) — stop polling after ~10s
         instead of retrying forever */
      if (!visible()){ if (++bootTries < 40) setTimeout(boot, 250); return; }
      wrapLabels();
      applyDockSkin();
      measure();
      snapTo(initialIdx(), true);
    }
    setTimeout(boot, 350);
  });
})();

/* Pastry product-card cart controls. Shopify's existing quick-add component
   remains responsible for the first add and all variant selection. */
(function(){
  "use strict";
  if (window.__pastryCardCart) return;
  window.__pastryCardCart = true;

  var cartState = null;
  var activeSlot = null;
  var mutationQueue = Promise.resolve();

  function root(){ return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/"; }
  function slots(){ return Array.prototype.slice.call(document.querySelectorAll("[data-pastry-card-cart]")); }
  function linesFor(cart, variantId){
    return (cart && cart.items || []).filter(function(item){ return String(item.variant_id) === String(variantId); });
  }
  function quantityFor(cart, variantId){
    return linesFor(cart, variantId).reduce(function(total, item){ return total + item.quantity; }, 0);
  }
  function announce(slot, message){
    var status = slot && slot.querySelector("[data-card-status]");
    if (!status) return;
    status.textContent = "";
    window.setTimeout(function(){ status.textContent = message; }, 20);
  }
  function setSlot(slot, quantity, ambiguous){
    if (!slot) return;
    quantity = Math.max(0, parseInt(quantity, 10) || 0);
    var quickAdd = slot.querySelector("quick-add-button");
    var control = slot.querySelector("[data-card-quantity]");
    var value = slot.querySelector("[data-card-quantity-value]");
    var viewCart = slot.querySelector("[data-card-view-cart]");
    slot.setAttribute("data-cart-quantity", String(quantity));
    if (value) value.textContent = String(quantity);
    if (ambiguous){
      if (quickAdd) quickAdd.hidden = true;
      if (control) control.hidden = true;
      if (viewCart){ viewCart.hidden = false; viewCart.textContent = "View cart · " + quantity; }
      return;
    }
    if (viewCart) viewCart.hidden = true;
    if (quantity > 0){
      if (quickAdd) quickAdd.hidden = true;
      if (control) control.hidden = false;
    } else {
      if (control) control.hidden = true;
      if (quickAdd) quickAdd.hidden = false;
      if (slot.getAttribute("data-requires-selection") === "true"){
        slot.removeAttribute("data-variant-id");
        if (quickAdd) quickAdd.removeAttribute("variant-id");
      }
    }
  }
  function applyCart(cart){
    cartState = cart;
    slots().forEach(function(slot){
      var variantId = slot.getAttribute("data-variant-id");
      if (!variantId || slot.__pastryPending) return;
      var matching = linesFor(cart, variantId);
      if (matching.length === 1) slot.setAttribute("data-line-key", matching[0].key);
      else slot.removeAttribute("data-line-key");
      setSlot(slot, quantityFor(cart, variantId), matching.length > 1);
    });
    return cart;
  }
  function fetchCart(){
    return fetch(root() + "cart.js", {headers:{Accept:"application/json"}}).then(function(response){
      if (!response.ok) throw new Error("Unable to read cart");
      return response.json();
    }).then(applyCart);
  }
  function post(url, body){
    return fetch(url, {
      method:"POST",
      headers:{Accept:"application/json","Content-Type":"application/json","X-Requested-With":"XMLHttpRequest"},
      body:JSON.stringify(body)
    }).then(function(response){
      return response.json().then(function(payload){
        if (!response.ok || payload.status) throw new Error(payload.description || payload.message || "Unable to update cart");
        return payload;
      });
    });
  }
  function updateQuantity(slot, quantity){
    var variantId = slot.getAttribute("data-variant-id");
    var lineKey = slot.getAttribute("data-line-key");
    var control = slot.querySelector("[data-card-quantity]");
    slot.__pastryPending = true;
    if (control) control.setAttribute("aria-busy", "true");
    setSlot(slot, quantity, false);

    mutationQueue = mutationQueue.catch(function(){ return null; }).then(function(){
      if (lineKey){
        return post((window.routes && window.routes.cart_change_url) || root() + "cart/change.js", {id:lineKey,quantity:quantity});
      }
      return post((window.routes && window.routes.cart_add_url) || root() + "cart/add.js", {id:variantId,quantity:quantity});
    }).then(fetchCart).then(function(cart){
      announce(slot, (slot.getAttribute("data-product-title") || "Product") + ". Quantity " + quantityFor(cart, variantId) + " in cart.");
      var modal = document.querySelector("cart-modal");
      if (modal && modal.open && typeof modal.reloadContent === "function") return modal.reloadContent();
    }).catch(function(error){
      console.error(error);
      announce(slot, error.message || "Unable to update cart.");
      return fetchCart().catch(function(){ return null; });
    }).finally(function(){
      slot.__pastryPending = false;
      if (control) control.setAttribute("aria-busy", "false");
    });
  }
  function handleClick(event){
    var slot = event.target.closest && event.target.closest("[data-pastry-card-cart]");
    if (!slot) return;
    if (event.target.closest("quick-add-button")){ activeSlot = slot; return; }
    var delta = event.target.closest("[data-card-increase]") ? 1 : event.target.closest("[data-card-decrease]") ? -1 : 0;
    if (!delta) return;
    event.preventDefault();
    var current = Math.max(0, parseInt(slot.getAttribute("data-cart-quantity"), 10) || 0);
    updateQuantity(slot, Math.max(0, current + delta));
  }
  function handleAdded(event){
    var detail = event.detail || {};
    var variantId = detail.id;
    if (!variantId) return;
    var candidates = slots().filter(function(slot){ return String(slot.getAttribute("data-variant-id")) === String(variantId); });
    var slot = activeSlot && document.documentElement.contains(activeSlot) ? activeSlot : candidates[0];
    if (slot){
      slot.setAttribute("data-variant-id", String(variantId));
      var quickAdd = slot.querySelector("quick-add-button");
      if (quickAdd) quickAdd.setAttribute("variant-id", String(variantId));
      setSlot(slot, (parseInt(slot.getAttribute("data-cart-quantity"), 10) || 0) + (parseInt(detail.quantity, 10) || 1), false);
    }
    activeSlot = null;
    window.setTimeout(function(){ fetchCart().catch(function(error){ console.error(error); }); }, 0);
  }
  function boot(){
    document.addEventListener("click", handleClick);
    document.addEventListener("product:added-to-cart", handleAdded);
    document.addEventListener("shopify:section:load", function(){ fetchCart().catch(function(error){ console.error(error); }); });
    window.addEventListener("pageshow", function(){ fetchCart().catch(function(error){ console.error(error); }); });
    fetchCart().catch(function(error){ console.error(error); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
